<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		@submit="submit"
		@close-modal="closeModal">
		<template slot="body">
        	<app-overlay-loader v-if="preloader" />
			<new-course-form-without-modal
				ref="newCourseForm"
				:table-id="tableId"
				:form-id="formId"
				:row-data="modalValue"
				:selected-url="selectedUrl"
				:on-after-submit="closeModal" />
		</template>
	</modal>
</template>

<script>
import NewCourseFormWithoutModal from "./FormWithoutModal";
import { ModalMixin } from "../../../../Mixins/ModalMixin.js";

export default {
	name: "ModalForm",
	components: { NewCourseFormWithoutModal },
	mixins: [ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
		selectedUrl: String,
	},
	data() {
		return {
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
		}
	},
	computed: {
		modalValue: {
			get() { return this.value; },
			set(newVal) { this.$emit('input', newVal); },
		},
	},
	methods: {
		submit() {
			this.$refs.newCourseForm.submit();
		},
	},
};
</script>
